// extracted by mini-css-extract-plugin
export default {"references-message":"_references-message_dde+l1"};